var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('AnalyticsSettingsStyled', _vm._l(_vm.analyticsSettings, function (ts) {
    return _c('AnalyticsSettingStyled', {
      key: ts.id,
      class: {
        active: ts.isActive
      },
      attrs: {
        "isActive": ts.isActive
      },
      on: {
        "click": function click($event) {
          return _vm.setAnlayticsSetting(ts.id);
        }
      }
    }, [_c('span', [_vm._v(_vm._s(ts.name))]), _c('transition', {
      attrs: {
        "name": "fade"
      }
    }, [ts.isActive ? _c('CheckIcon') : _vm._e()], 1)], 1);
  }), 1);
}
var staticRenderFns = []

export { render, staticRenderFns }